import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "codeblock-container" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "copy-btn-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("pre", {
      ref: "pre",
      class: _normalizeClass(`${_ctx.languageClass} pre`)
    }, [
      _createElementVNode("code", {
        class: _normalizeClass(`${_ctx.languageClass} code`),
        innerHTML: _ctx.html
      }, null, 10, _hoisted_2)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_tooltip, {
        text: "Copy code",
        location: "top"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            icon: "mdi-content-copy",
            size: "small",
            variant: "text",
            color: "primary",
            onClick: _ctx.copyCode,
            "aria-label": "Copy code"
          }), null, 16, ["onClick"])
        ]),
        _: 1
      })
    ])
  ]))
}